module.exports = __webpack_public_path__ + "img/aqi_lv2.dd203d04.png";